import { forwardRef } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import { CCheckbox } from 'components/atoms';
import { ICCheckboxWithLabel } from 'types/molecules';
import customTwMerge from 'utils/twMerge';

const CCheckboxWithLabel = forwardRef<HTMLLabelElement, ICCheckboxWithLabel>(
  (
    {
      iconType,
      iconClassName,
      labelClassName,
      className,
      checkboxClassName,
      checkboxCheckedClassName,
      ...rest
    },
    ref
  ) => {
    return (
      <FormControlLabel
        {...rest}
        ref={ref}
        control={
          <CCheckbox
            iconType={iconType}
            iconClassName={iconClassName}
            className={checkboxClassName}
            checkedClassName={checkboxCheckedClassName}
          />
        }
        classes={{
          label: customTwMerge('pl-3 text-body12 text-neutral-500', labelClassName),
          asterisk: 'text-body12 text-danger',
        }}
        className={customTwMerge('mx-0 select-none', className)}
      />
    );
  }
);

export default CCheckboxWithLabel;
